<div fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

  <div class="layout-padd divider full-w  secure-btn pad10"  fxLayoutAlign="space-between">

    <div fxLayoutAlign="center center" >
      
      <span class="mat-title ">{{'StripecardscaComponent.card'|translate}}</span>
    </div>

    <div fxLayoutGap="10px" fxLayoutAlign="center center">
      <img src=" assets/img/stripe-logo/powered_by.png">
    </div>

  </div>

  <!-- Add card form-->
  <div fxLayout="column" fxLayoutGap="20px" class="layout-padd scrolled heigstripe ">

    <div fxLayout="column" fxLayoutGap="5px">

      <!-- Numero card input -->
      <div fxLayout="row" class="full-w ">

        <div fxFlex="30" fxLayoutAlign="start center" class="layout-padd">
          <span class="mat-subheading-1">{{'StripecardscaComponent.numberCard'|translate}} </span>
          <span class="brand"><i class="pf pf-credit-card" id="brand-icon"></i></span>
        </div>

        <div fxFlex fxLayoutAlign="center center">
          <div id="cardNumber" class="full-w"></div>
        </div>

      </div>

      <!-- Expiration card input -->
      <div fxLayout="row" class="full-w   " style="margin-top: 10px;">

        <div fxFlex="30" fxLayoutAlign="start center" class="layout-padd">
          <span class="mat-subheading-1">{{'StripecardscaComponent.exp'|translate}} </span>
        </div>

        <div fxFlex fxLayoutAlign="center center">
          <div id="cardExpiry" class="full-w"></div>
        </div>

      </div>

      <!-- CVC card input -->
      <div fxLayout="row" class="full-w">

        <div fxFlex="30" fxLayoutAlign="start center" class="layout-padd">
          <span class="mat-subheading-1">CVC</span>
        </div>

        <div fxFlex fxLayoutAlign="center center">
          <div id="cardCvc" class="full-w"></div>
        </div>

      </div>

    </div>

    <div class="layout-padd-l" *ngIf="user$">
      <mat-checkbox angulartics2On="click" angularticsAction="checkBoxRegisterForLater"
        angularticsCategory="paymentMethods" [(ngModel)]="rememberCard" > <span style="padding-left: 5px;">
          {{'StripecardscaComponent.saveCard'|translate}} </span>
      </mat-checkbox>
    </div>

    <!-- Error and Submit button -->
    <div fxLayout="column" fxLayoutGap="5px">

      <!-- Error message -->
      <div fxLayout="row" fxLayoutAlign="center center" class="warn rad-bord layout-padd text-center"
        *ngIf="errorMessage">
        <span class="mat-subheading-1">{{errorMessage}}</span>
      </div>



      <div   class="layout-padd positionBottomstripe" fxLayoutGap="10px" fxflex>

        <button mat-stroked-button class="dark-ico rounded-button" fxFlex (click)="closeDial()">
            <span class="mat-title">{{ "cancel_button"|translate}}</span>
        </button>


        <button mat-stroked-button class="primary rounded-button" fxFlex   (click)="submitForm()" angulartics2On="click"
        angularticsAction="submitCreate" angularticsCategory="paymentMethods">
            <span class="mat-title">{{"validate-button"|translate}}</span>
        </button>

    </div>  
     

    </div>

  </div>

</div>


<app-popup-loader [flagLoading]="loader" [size]="30"></app-popup-loader>
